import classNames from 'classnames'
import Image from 'next/image'

import { Tint } from '@/shared/components/typography'

const FadeInNotice = () => {
  return (
    <div className={classNames(`fade-in absolute -top-6 left-1/2 inline-block w-fit -translate-x-1/2`)}>
      <div className="rounded-[27px] bg-[#FF9052] px-2 py-[3px] text-sm font-medium text-white">
        <Tint color="text010" level="tint1">
          주차시작 12시간 전까지 무료취소
        </Tint>
      </div>
      <Image className="absolute -bottom-[6px] left-0" src="/icons/tail.svg" alt="꼬리" width={16} height={16} />
    </div>
  )
}

export default FadeInNotice
